import React from "react"
import { Box, Card, Grid, Typography } from "@material-ui/core"
import { formatarCPFCNPJ } from "utils/cpfcnpj-format"
import { useStyles } from "./card-empresa-styles"
import { AvancarIcon } from "components/icons/avancar-icon"
import classNames from "classnames"
import { RestauranteIcon } from "components/icons/restaurante-icon"
import { TokenGestaoEmpresaModel } from "api/touchone/models/token-gestao-empresa"

export type CardEmpresaProps = {
    model: TokenGestaoEmpresaModel
    onClick: (empresaId: string) => void
    selecionado?: boolean
}

export const CardEmpresa = ({ model, onClick, selecionado }: CardEmpresaProps) => {
    const classes = useStyles();
    return (
        <Card className={classNames(classes.card, selecionado && classes.selecionado)} onClick={() => onClick(model.Id)}>
            <Box p={2}>
                <Grid container spacing={2}>
                    <Grid item xs={"auto"}>
                        <Box display="flex" alignItems="center" height={"100%"}>
                            <RestauranteIcon tipo="BUTTON" class={classes.icon} />
                        </Box>
                    </Grid>
                    <Grid item xs>
                        <Box>
                            <Typography variant="body1" color="primary" className={classes.negrito}>
                                {model.Descricao}
                            </Typography>
                            <Typography variant="body2">
                                {formatarCPFCNPJ(model.Documento)}
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs="auto">
                        <Box display="flex" alignItems="center" height={"100%"}>
                            <AvancarIcon tipo="BUTTON" class={classes.icon} />
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </Card>
    )
}